import React from "react";

function ManagedWeightTable({ users, onOpenModal }) {
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped align-middle text-center">
        <thead className="table-light">
          <tr>
            <th>帳號</th>
            <th>姓名</th>
            <th>最新體重(公斤)</th>
            <th>平均體重(公斤)</th>
            <th>最新記錄時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.userId}>
              <td>{u.account}</td>
              <td>{u.name}</td>
              <td>{u.latestWeightInKg ?? "-"}</td>
              <td>{u.avgWeightInKg?.toFixed(1) ?? "-"}</td>
              <td>{u.updatedAtW?.slice(0, 16) ?? "-"}</td>
              <td>
                <div className="d-grid gap-1">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => onOpenModal("weight", u)}
                  >
                    新增紀錄
                  </button>
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => onOpenModal("weightHistory", u)}
                  >
                    歷史記錄
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ManagedWeightTable;
